import { useGlobalContext } from "../../../context/store";
import { Link } from "react-router-dom";
import FabrioLogo from "../../../assets/Fabrio-Logo.png";
import ErrorBoundary from "../../../ErrorBoundary";

export default function Sidebar() {
  const { sidebarState, toggleSidebar } = useGlobalContext();

  var windowSizeSmall: boolean = false;

  if (typeof window !== "undefined") {
    windowSizeSmall = window.screen.width < 769;
  }

  return (
    <ErrorBoundary>
      <div
        className={
          sidebarState
            ? "sidebar h-screen px-4 overflow-auto sidebar-active"
            : "sidebar-inactive"
        }
      >
        <div className="sticky top-logo top-0 py-6 bg-[#212631] z-10">
          <img
            src={FabrioLogo}
            alt="Fabrio Logo"
            className="max-w-full object-contain mx-auto max-h-12 rounded-full bg-white p-1"
          />
          <h5 className="text-center text-xl my-2">FABRIO INDIA</h5>
          <hr className="mx-auto" />
        </div>
        <ul className="list-none text-start">
          <li
            className="my-3"
            // onClick={windowSizeSmall ? () => toggleSidebar() : () => {}}
            onClick={windowSizeSmall ? () => toggleSidebar() : () => {}}
          >
            <Link className="nav-link text-nowrap" to="/work-contract-register">
              Work Contract Register
            </Link>
          </li>
          <li
            className="my-3"
            // onClick={windowSizeSmall ? () => toggleSidebar() : () => {}}
            onClick={windowSizeSmall ? () => toggleSidebar() : () => {}}
          >
            <Link className="nav-link text-nowrap" to="/fabric-inward-register">
              Fabric Inward Register
            </Link>
          </li>
          <li
            className="my-3"
            // onClick={windowSizeSmall ? () => toggleSidebar() : () => {}}
            onClick={windowSizeSmall ? () => toggleSidebar() : () => {}}
          >
            <Link
              className="nav-link text-nowrap"
              to="/fabric-outward-register"
            >
              Fabric Outward Register
            </Link>
          </li>
          <li
            className="my-3"
            onClick={windowSizeSmall ? () => toggleSidebar() : () => {}}
          >
            <Link className="nav-link text-nowrap" to="/status-update">
              Status Update
            </Link>
          </li>
        </ul>
      </div>
    </ErrorBoundary>
  );
}
